import _extends from '@babel/runtime/helpers/extends';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { TextButton, isMobileStyleMixin, Icon, useIsMobile, TaktIdConsumer, createStormTaktId, BottomSheet, Tooltip } from '@amzn/storm-ui';
import { i as infoCircle } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-DdYjRvf4.js';

const TooltipButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30063520__sc-22uv9b-0"
})(["vertical-align:middle;border:none;background:transparent;padding:", ";margin:", ";outline:none;position:relative;top:-1px;", ""], ({
  theme
}) => theme.helptip.triggerIcon.padding, ({
  theme
}) => theme.helptip.triggerIcon.margin, isMobileStyleMixin(css(["padding:", ";"], ({
  theme
}) => theme.helptip.triggerIcon.mobile.padding)));
const TooltipIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30063520__sc-22uv9b-1"
})(["color:", ";display:block;font-size:", ";:hover{color:", ";cursor:pointer;}", ""], ({
  theme
}) => theme.helptip.triggerIcon.color, ({
  theme
}) => theme.helptip.triggerIcon.size, ({
  theme
}) => theme.helptip.triggerIcon.hoverColor, isMobileStyleMixin(css(["font-size:", ";"], ({
  theme
}) => theme.helptip.triggerIcon.mobile.size)));
TooltipIcon.displayName = 'TooltipIcon';
const AdaptiveHelpTip = props => {
  const isMobile = useIsMobile();
  const [bottomSheetIsOpen, setBottomSheetIsOpen] = useState(false);
  const {
    children,
    id,
    renderTrigger,
    triggerLabel,
    triggerProps,
    tooltipProps,
    bottomSheetProps,
    taktId,
    taktValue
  } = props;
  return isMobile ? /*#__PURE__*/React.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('adaptive-help-tip')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheet, _extends({
    closeButton: {
      type: 'icon',
      label: 'close'
    }
  }, bottomSheetProps, {
    isOpen: bottomSheetIsOpen,
    onClose: () => setBottomSheetIsOpen(false)
  }), children), /*#__PURE__*/React.createElement(TooltipButton, _extends({}, getDataTaktAttributes({
    taktIdSuffix: 'trigger-button'
  }), triggerProps, {
    type: "button",
    "aria-label": triggerLabel,
    onClick: () => setBottomSheetIsOpen(true)
  }), renderTrigger))) : /*#__PURE__*/React.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('adaptive-help-tip')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React.createElement(Tooltip, _extends({}, tooltipProps, {
    id: id,
    trigger: /*#__PURE__*/React.createElement(TooltipButton, _extends({}, getDataTaktAttributes({
      taktIdSuffix: 'trigger-button'
    }), triggerProps, {
      type: "button",
      "aria-label": triggerLabel
    }), renderTrigger),
    message: children
  })));
};
AdaptiveHelpTip.propTypes = {
  /**
   * Supplied to the popover element. Useful for identifying the tooltip in front-end telemetry.
   */
  id: PropTypes.string,
  /**
   * Render prop used to override the trigger icon of the `<AdaptiveHelpTip>`.
   */
  renderTrigger: PropTypes.node,
  /**
   * Label for the trigger icon.
   */
  triggerLabel: PropTypes.string,
  /**
   * Additional props that are applied to the help tip trigger `<TextButton />`.
   */
  triggerProps: PropTypes.objectOf(PropTypes.any),
  /**
   * [Additional props](/components/tooltip/?tab=code#tooltip-props) that are applied to the `<Tooltip />`.
   */
  tooltipProps: PropTypes.objectOf(PropTypes.any),
  /**
   * [Additional props](/components/sheet/?tab=code#bottomsheet-props) that are applied to the `<BottomSheet />`.
   */
  bottomSheetProps: PropTypes.objectOf(PropTypes.any)
};
AdaptiveHelpTip.defaultProps = {
  id: '',
  triggerLabel: 'Open tooltip',
  triggerProps: {},
  tooltipProps: {},
  bottomSheetProps: {},
  renderTrigger: /*#__PURE__*/React.createElement(TooltipIcon, {
    type: infoCircle,
    blockSize: true
  })
};

export { AdaptiveHelpTip as A };
//# sourceMappingURL=AdaptiveHelpTip-BnTIqJkT.js.map
